import { createContext, useContext, useState, useRef, useEffect, useCallback } from "react";
import api from "@/lib/api";

const PlayerContext = createContext(null);
export const usePlayer = () => useContext(PlayerContext);

export function PlayerProvider({ children }) {
  const [current, setCurrent] = useState(null); // radio media object
  const [playing, setPlaying] = useState(false);
  const [volume, setVolume] = useState(1);
  const audioRef = useRef(null);

  const playRadio = useCallback((media) => {
    if (current && current.id === media.id) {
      setPlaying((p) => !p);
    } else {
      setCurrent(media);
      setPlaying(true);
    }
  }, [current]);

  const togglePlay = useCallback(() => setPlaying((p) => !p), []);
  const stop = useCallback(() => { setPlaying(false); setCurrent(null); }, []);

  useEffect(() => {
    const a = audioRef.current;
    if (!a || !current) return;
    if (a.src !== current.audio_url) {
      a.src = current.audio_url;
    }
    if (playing) {
      a.play().catch(() => setPlaying(false));
    } else {
      a.pause();
    }
  }, [current, playing]);

  useEffect(() => {
    if (audioRef.current) audioRef.current.volume = volume;
  }, [volume]);

  useEffect(() => {
    if (!playing || !current?.id) return;
    const t = setInterval(() => {
      api.post(`/media/${current.id}/heartbeat`, { seconds: 15 }).catch(() => {});
    }, 15000);
    return () => clearInterval(t);
  }, [playing, current]);

  return (
    <PlayerContext.Provider value={{ current, playing, volume, setVolume, playRadio, togglePlay, stop }}>
      {children}
      <audio ref={audioRef} preload="none" />
    </PlayerContext.Provider>
  );
}
